module.exports = __webpack_public_path__ + "media/images/area/feature/kansai/related/zh-hant/4-a670cd469147c6c278ad57ed59a1fe25.jpg";